import DOMPurify from 'dompurify';
export const sanitize = (html, options) => {
    options?.hook?.(DOMPurify);
    return DOMPurify.sanitize(html, {
        ...options?.dompurify,
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false
    });
};
